export default __webpack_public_path__ + "static/1_28-39462078467b87e4dc8af429f9ff9a11.png";